module.exports = new __parcel__URL__("Logo_Consili18.b355edea.svg").toString();